export enum PlanDomain {
  ENVISIONING,
  PLANNING,
  IMPLEMENTING,
  EVALUATING,
  OUTPUTS
}
